


























































import Vue from 'vue';
import { CampaignMessageToken, Integration } from '@/models';
import { audienceCustomerListRules, campaignMessageTokenRules } from '@/rules/campaign.rules';
import CampaignService from '../../services/CampaignService';

export default Vue.extend({
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    textMessage: String,
  },
  data() {
    return {
      phoneMask: '# ####-####',
      dddMask: '###',
      rules: {
        ...audienceCustomerListRules.attr,
        token: {
          ...campaignMessageTokenRules.attr,
        },
      },
      platform: String,
      phoneCountryCode: Number,
      phoneAreaCode: Number,
      phoneNumber: Number,
      tokens: [] as CampaignMessageToken[],
    };
  },
  async mounted() {
    if (this.textMessage) {
      this.extractTokens(this.textMessage);
    }
  },
  methods: {
    async onFinish() {
      this.$emit('close');
    },
    async sendMessage(send: boolean) {
      try {
        const chatId = `${this.phoneCountryCode}${this.phoneAreaCode}${this.phoneNumber}`;
        const smsIntegration = this.$store.state.integration.integrations.find(
          (i: Integration) =>  i.platform === 'sms');

        const finalText = CampaignService.replaceTokenFromText(this.textMessage, this.tokens);
        
        const params = {
          chatId,
          type: 'SMS',
          text: finalText,
          integrationId: smsIntegration.configuration.defaultWabIntegration || smsIntegration.objectId
        };

        await this.$store.dispatch('sendSMSMessage', params);

        this.$store.commit('addSnackbar', {
          text: `Mensagem enviada com sucesso`,
          color: 'success',
        });
        this.$emit('close');
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao enviar mensagem: ${error.text}`,
        });
        this.$emit('close');
      }
    },
    extractTokens(text: string) {
      const newTokens = CampaignService.extractTokensFromText(text);
      this.tokens = [];
      for (const token of newTokens) {
        this.tokens.push({ name: token, value: '' });
      }
    },
  },
  watch: {
    textMessage(val) {
      this.extractTokens(val);
    },
  },
  computed: {
    show: {
      get(): boolean {
        return this.showDialog;
      },
      set(showDialog: boolean) {
        if (!showDialog) {
          this.$emit('close');
        }
      },
    },
  },
});
